interface Props {
  color?: string;
}

function DeleteCircle(props: Props) {
  const { color } = props;

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7528_152779)">
        <path
          className="icon-svg"
          d="M15.0283 8.97144L8.97119 15.0286M8.97119 8.97144L15.0283 15.0286"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className="icon-svg"
          d="M12.0001 21.2858C17.1284 21.2858 21.2858 17.1284 21.2858 12.0001C21.2858 6.87171 17.1284 2.71436 12.0001 2.71436C6.87171 2.71436 2.71436 6.87171 2.71436 12.0001C2.71436 17.1284 6.87171 21.2858 12.0001 21.2858Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7528_152779">
          <rect width="20" height="20" fill="white" transform="translate(2 2)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default DeleteCircle;
